var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grade",class:{
    selected: _vm.activated && _vm.selected,
    'not-selected': _vm.activated && !_vm.selected,
  },style:(_vm.style)},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }